<template>
  <div class="v-start-sale">
    <nuxt-link
      :to="`${link}`"
      class="v-start-sale_btn"
    >
      <span class="v-start-sale_text">{{ title }}</span>
      <span class="v-start-sale_more">Подробнее</span>
      <img
        src="~/assets/img/svg/common/arrow-right-slider.svg"
        alt="arrow"
      >
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title:string;
	link:string;
}>();

onMounted(() => {
  document.body.classList.add('sale-slider__padding');
});

onBeforeUnmount(() => {
  document.body.classList.remove('sale-slider__padding');
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/media";

.v-start-sale {
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background-color: #ffc115;
}

.v-start-sale_btn {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 28px;
  margin-left: 24px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: .02em;
		color: var(--primary);

  & .v-start-sale_text {
    font-size: 16px;
    margin-right: 24px;
    display: block;
  }

  & .v-start-sale_more {
    font-size: 16px;
    display: block;
  }

  & > img {
    width: 14px;
    height: 14px;
    opacity: .4;
    margin-left: 12px;
  }
}

@include media('sm') {
  .v-start-sale_btn {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    & .v-start-sale_text {
      margin-right: 0;
      font-size: 14px;
    }

    & > .v-start-sale_more {
      display: none;
    }

    & > img {
    }
  }
}
</style>
